import React, { useEffect, useState } from 'react';
import { LinkedAccount, fetchLinkedAccounts, switchAccount } from '../lib/accounts';

// Prepínač okruhov pod hlavičkou. Ukáže sa len osobe s prepojenými účtami.
// Pri každom okruhu je počet dokladov, ktoré v ňom na ňu čakajú.
export default function AccountSwitcher({ onLoaded }: { onLoaded?: (accounts: LinkedAccount[]) => void }) {
  const [accounts, setAccounts] = useState<LinkedAccount[]>([]);
  const [busy, setBusy] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    const load = () => fetchLinkedAccounts().then(a => { if (alive) { setAccounts(a); onLoaded?.(a); } });
    load();
    const id = setInterval(() => { if (document.visibilityState === 'visible') load(); }, 60000);
    return () => { alive = false; clearInterval(id); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (accounts.length < 2) return null;

  const go = async (a: LinkedAccount) => {
    if (a.current || busy) return;
    setBusy(a.userId);
    setError(null);
    try {
      await switchAccount(a.userId);
      window.location.href = '/dashboard';
    } catch (e: any) {
      setError(e?.response?.data?.error || 'Prepnutie sa nepodarilo.');
      setBusy(null);
    }
  };

  return (
    <div className="acc-bar">
      <span className="acc-bar-label">Okruh</span>
      <div className="acc-bar-items">
        {accounts.map(a => (
          <button key={a.userId} type="button"
            className={`acc-pill${a.current ? ' is-current' : ''}`}
            onClick={() => go(a)} disabled={busy !== null}
            title={a.current ? 'Tu práve pracuješ' : `Prepnúť na ${a.tenantName}`}>
            <span className="acc-pill-name">{busy === a.userId ? 'Prepínam…' : a.tenantName}</span>
            <span className={`acc-pill-count${a.pending > 0 ? ' has-pending' : ''}`}>{a.pending}</span>
          </button>
        ))}
      </div>
      {error && <span className="acc-bar-error">{error}</span>}
    </div>
  );
}
